import React from "react";
import { Lock, Plus, Users } from "lucide-react";
import { fmtDay, slotPrice } from "../../lib/prenotazioniApi";

// Griglia settimana: righe = fasce orarie, colonne = 7 giorni. Scorre in orizzontale sul telefono in verticale.
export function WeekGrid({ svc, days, slots, bookings, blocks, prices, today, onCell, onBooking, onBlock }) {
  const at = (day, slotId) => bookings.filter((b) => b.date === day && b.slot_id === slotId && b.status !== "cancelled");
  const blockFor = (day, slotId) => blocks.find((b) => b.date === day && b.slot_id === null) || blocks.find((b) => b.date === day && b.slot_id === slotId) || null;
  return (
    <div className="overflow-x-auto rounded-2xl border border-[#e8dcc8] bg-white" data-testid={`week-grid-${svc}`}>
      <table className="w-full min-w-[700px] text-xs border-separate border-spacing-0">
        <thead>
          <tr>
            <th className="sticky left-0 z-10 bg-[#faf3ee] text-left px-2 py-2 w-20 text-[10px] uppercase tracking-wide text-[#7c5a4e]">Orario</th>
            {days.map((d) => (
              <th key={d} className={`px-1 py-2 text-center font-bold capitalize ${d === today ? "bg-[#4a1c17] text-white" : "bg-[#faf3ee] text-[#2b1410]"}`} data-testid={`week-day-${d}`}>{fmtDay(d)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {slots.map((s) => (
            <tr key={s.id}>
              <td className="sticky left-0 z-10 bg-white border-t border-[#f1e6da] px-2 py-1 font-semibold text-[#4a1c17] whitespace-nowrap">{s.start}<div className="text-[10px] font-normal text-[#9a8070]">{s.end}</div></td>
              {days.map((d) => {
                const list = at(d, s.id); const bl = blockFor(d, s.id); const past = d < today;
                return (
                  <td key={d} className={`border-t border-l border-[#f1e6da] p-1 align-top h-16 ${d === today ? "bg-[#fdf6e9]/60" : ""}`}>
                    {list.length > 0 ? list.map((b) => (
                      <button key={b.id} onClick={() => onBooking(b)} className={`w-full text-left rounded-lg px-1.5 py-1 mb-1 ${b.whatsapp_notified ? "bg-purple-100 text-purple-900" : "bg-amber-100 text-amber-900"} active:scale-95 transition-transform`} data-testid={`cell-booking-${b.id}`}>
                        <div className="font-bold truncate">{b.name}</div>
                        <div className="inline-flex items-center gap-1 text-[10px]"><Users className="h-3 w-3" /> {b.num_people} · € {b.price || slotPrice(svc, s.id, d, prices) * (b.num_people || 1)}</div>
                      </button>
                    )) : bl ? (
                      <button onClick={() => onBlock(bl)} className="w-full h-full min-h-[52px] rounded-lg bg-neutral-100 text-neutral-500 inline-flex flex-col items-center justify-center gap-0.5" title={bl.reason || "Chiuso"} data-testid={`cell-blocked-${d}-${s.id}`}><Lock className="h-3.5 w-3.5" /><span className="text-[10px] truncate max-w-full px-1">{bl.reason || "Chiuso"}</span></button>
                    ) : (
                      <button onClick={() => onCell(d, s)} disabled={past} className={`w-full h-full min-h-[52px] rounded-lg border border-dashed ${past ? "border-transparent text-transparent" : "border-emerald-300 text-emerald-700 hover:bg-emerald-50"} inline-flex flex-col items-center justify-center`} data-testid={`cell-free-${d}-${s.id}`}>
                        <Plus className="h-4 w-4" /><span className="text-[10px]">€ {slotPrice(svc, s.id, d, prices)}{svc === "spa" ? "/p" : ""}</span>
                      </button>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
